import {
  BankingHoursConfiguration,
  IntervalConfiguration,
} from "./configurationProvider";

export const getOutsideBankingHoursLabel = () =>
  BankingHoursConfiguration.outsideHoursLabel;

export const isOutsideBankingHours = (date = new Date()) => {
  const { startHour, startMinute, endHour, endMinute } =
    BankingHoursConfiguration;

  const totalMinutes =
    date.getHours() * IntervalConfiguration.minuteInSecond + date.getMinutes();
  const bankingStart =
    startHour * IntervalConfiguration.minuteInSecond + startMinute;
  const bankingEnd = endHour * IntervalConfiguration.minuteInSecond + endMinute;

  return totalMinutes < bankingStart || totalMinutes >= bankingEnd;
};
